import React from "react";

export const blondinettePublishedAt = (
  <span className="white">
    <i>Teatro V1</i> (1963) y <i>Blondinette</i> (1973)'
  </span>
);
